import { ChangeDetectionStrategy, Component, inject, linkedSignal, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ImpresorasService } from '../../../features/configuration/services/impresoras.service';
import { PrinterTypes } from '../../constants/printer-types';
import { readLocalStorage } from '../../services/session-manager';
import { Select } from '../select/select';

@Component({
  selector: 'app-printer-selection-dialog',
  templateUrl: './printer-selection-dialog.html',
  imports: [FormsModule, Select],
  styleUrl: './printer-selection-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrinterSelectionDialog {
  readonly printerService = inject(ImpresorasService);
  readonly printers = this.printerService.resources.getListFromSucursal();
  public readonly etiquetaPrinter = linkedSignal<string | null>(() => readLocalStorage(PrinterTypes.Etiquetas));
  public readonly guiaPrinter = linkedSignal<string | null>(() => readLocalStorage(PrinterTypes.Guias));
  public readonly defaultPrinter = linkedSignal<string | null>(() => readLocalStorage(PrinterTypes.Predeterminada));

  public readonly defaultPrinterRequired = signal<boolean>(false);
  public readonly guiaPrinterRequired = signal<boolean>(false);
  public readonly etiquetaPrinterRequired = signal<boolean>(false);

  constructor(public activeModal: NgbActiveModal) { }

  close(result = false): void {
    if (result) {
      localStorage.setItem(PrinterTypes.Etiquetas, this.etiquetaPrinter() ?? '');
      localStorage.setItem(PrinterTypes.Guias, this.guiaPrinter() ?? '');
      localStorage.setItem(PrinterTypes.Predeterminada, this.defaultPrinter() ?? '');
    }
    this.activeModal.close(result);
  }
}
